<div class="ai-personalization-container">
    <sfx-toolbar enableDivider>
        {{ 'Personalize AI' | translate }}
    </sfx-toolbar>

    <sfx-content>
        <sfx-header>
            {{ 'Company settings' | translate }}
        </sfx-header>
        <sfx-section>
            <form id="companySettingsForm" name="companySettingsForm" class="ai-settings-form-container" data-layout="column">
                <mat-form-field name="company-name-field" class="company-name-field" data-lpignore="true">
                    <mat-label>{{ 'Name' | translate }}</mat-label>
                    <textarea name="companyNameInput" matInput [(ngModel)]="companyName" (ngModelChange)="onFieldChange()" [matTooltip]="EditorTooltip" [readonly]="!IsAdmin" columns="100" rows="1" ></textarea>
                </mat-form-field>
                <mat-form-field name="company-summary-field" class="company-summary-field" data-lpignore="true">
                    <mat-label>{{ 'Summary' | translate }}</mat-label>
                    <textarea name="companySummaryInput" matInput [(ngModel)]="companySummary" (ngModelChange)="onFieldChange()" [matTooltip]="EditorTooltip" [readonly]="!IsAdmin" columns="100" ></textarea>
                </mat-form-field>
            </form>
        </sfx-section>

        <sfx-header>
            {{ 'User settings' | translate }}
        </sfx-header>
        <sfx-section>
            <form #userSettingsForm="ngForm" id="userSettingsForm" name="userSettingsForm" class="password-form-container" data-layout="column">
                <mat-form-field class="user-name-field" data-lpignore="true">
                    <mat-label>{{ 'Name' | translate }}</mat-label>
                    <textarea name="userNameInput" matInput [(ngModel)]="userName" (ngModelChange)="onFieldChange()" columns="100" rows="1" ></textarea>
                </mat-form-field>
                <mat-form-field class="user-summary-field" data-lpignore="true">
                    <mat-label>{{ 'Summary' | translate }}</mat-label>
                    <textarea name="userSummaryInput" matInput [(ngModel)]="userSummary" (ngModelChange)="onFieldChange()" columns="100" ></textarea>
                </mat-form-field>
            </form>
        </sfx-section>

        <sfx-section>
            <p class="information"><i>{{ 'This information will be used to personalize your AI suggestions.' | translate }}</i></p>
        </sfx-section>
    </sfx-content>
</div>